import React from 'react';
import { makeStyles, Typography } from '@popmenu/common-ui';
import { FormattedMessage } from 'react-intl';
import RestaurantInfoStep from '../RestaurantInfoStep/RestaurantInfoStep.imports-loadable';
import WebsiteFields from '../SiteInformationStep/WebsiteFields';
import SignUpStep from '../SignUpStep/SignUpStep';
import type { PlanStep } from './StarterPlan';

const useStyles = makeStyles(theme => ({
  sectionTitle: {
    marginBottom: theme.spacing(2),
  },
}));

const MenuEmbedRestaurantInfoStep = () => {
  const classes = useStyles();
  return (
    <RestaurantInfoStep>
      <Typography variant="h6" className={classes.sectionTitle}>
        <FormattedMessage
          defaultMessage="Help us get your menu started"
        />
      </Typography>
      <WebsiteFields />
    </RestaurantInfoStep>
  );
};

const MENU_EMBED_STEPS: PlanStep[] = [
  { component: MenuEmbedRestaurantInfoStep, name: 'restaurant_info_step' },
  { component: SignUpStep, name: 'sign_up_step' },
];

export default MENU_EMBED_STEPS;
